import React from "react"

export default function Footer() {
  return (
    <footer className="gradient text-xs text-center pb-4">
      <p className="pr-2">
        Copyright &copy; 2020, F_Tokumitsu. All Rights Reserved.
      </p>
    </footer>
  )
}
